import { DataToast } from 'components';
import { IDataToast } from 'components/DataToast';
import { ReactNode } from 'react';
import { toast, ToastOptions, TypeOptions } from 'react-toastify';

type Toaster = (content: ReactNode, title?: string, options?: ToastOptions<IDataToast>) => void;

export const createToast =
  (type: TypeOptions) =>
  (content: ReactNode, title?: string, options: ToastOptions<IDataToast> = {}) =>
    (toast as any)[type](DataToast, {
      data: { content, title },
      ...options
    });

export const toaster = (['success', 'error', 'warning', 'info'] as TypeOptions[]).reduce(
  (acc, value) => ({ ...acc, [value]: createToast(value) }),
  {} as Record<TypeOptions, Toaster>
);
